import { SupportFormContainter } from "../support/supportElements";
import {
  FormControl,
  FormLabel,
  Grid,
  Paper,
  TextField,
  MenuItem,
  Select,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { ButtonDark } from "../button/buttonElements";
import { useFormik } from "formik";
import { SendSupportMessage } from "../../services/ProtectedService";
import { FCT_IRS_VALIDATION } from "../../constants/defaultValues";
import axios from "axios";
import * as Yup from "yup";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState, useEffect } from "react";
import Loader from "react-spinners/BounceLoader";
import Modal from "../modal/modal";

const MDAForm = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [verifyingTIN, setVerifyingTIN] = useState(false);
  const [tinVerified, setTinVerified] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [amount, setAmount] = useState("");
  const [transactionRefId, setTransactionRefId] = useState("");

  const paymentRecipients = ["NIMASA"];

  const taxTypes = [
    { taxTypeId: "CGT", taxTypeName: "CAPITAL GAINS TAX" },
    { taxTypeId: "PIT", taxTypeName: "PIT-Direct Assessment" },
    { taxTypeId: "WHT", taxTypeName: "Withholding Tax" },
    { taxTypeId: "PAYE", taxTypeName: "PAYE" },
    { taxTypeId: "BPRF", taxTypeName: "Business Premises Registration Fee" },
    { taxTypeId: "DL", taxTypeName: "Development Levy" },
    { taxTypeId: "EECT", taxTypeName: "Entertainment and Event Centre Tax" },
    { taxTypeId: "FCTIRSFEE", taxTypeName: "FCTIRS FEES" },
    { taxTypeId: "GR", taxTypeName: "Ground Rate" },
    { taxTypeId: "MTL", taxTypeName: "Market Taxes and Levies" },
    { taxTypeId: "NSRF", taxTypeName: "Naming of Street Registration Fees" },
    {
      taxTypeId: "PBLGCT",
      taxTypeName: "Pools Betting, Lotteries, Gaming & Casino Taxes",
    },
    { taxTypeId: "POL", taxTypeName: "Pre-Operational Levy" },
    { taxTypeId: "PT", taxTypeName: "Property Tax" },
    { taxTypeId: "ROFL", taxTypeName: "Right of Occupancy Fees on lands" },
    { taxTypeId: "RT", taxTypeName: "Road Taxes" },
    {
      taxTypeId: "SDIEI",
      taxTypeName: "Stamp Duties on Instruments executed by Individuals",
    },
    {
      taxTypeId: "TMABCBN",
      taxTypeName: "TRANSFER OF MDA ACCOUNT BALANCE TO CBN",
    },
    { taxTypeId: "OTHERS", taxTypeName: "OTHERS" },
  ];

  const currencies = [
    "NGN - Nigerian Naira",
    "GHS - Ghanaian Cedi",
    "ZAR - South African Rand",
    "USD - US Dollar",
    "EUR - Euro",
  ];

  const formatNumber = (value) => {
    if (value === "" || value === null) return "";
    const num = parseFloat(value.toString().replace(/,/g, ""));
    if (isNaN(num)) return "";
    return num.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    });
  };

  const parseNumber = (value) => {
    return value.replace(/,/g, "");
  };

  const formik = useFormik({
    initialValues: {
      tin: "",
      recipient: "Fct-Irs", // Default value
      taxType: "",
      amount: "",
      payerName: "",
      payerEmail: "",
      currency: "NGN - Nigerian Naira",
      payerPhone: "",
    },
    validationSchema: Yup.object({
      tin: Yup.string()
        .required("TIN is required")
        .matches(/^\d{9,12}$/, "TIN must be 9-12 digits"),
      recipient: Yup.string().required("Required"),
      taxType: Yup.string().required("Required"),
      amount: Yup.number()
        .min(0.01, "Amount must be greater than 0")
        .required("Required"),
      payerName: Yup.string().required("Required"),
      payerEmail: Yup.string()
        .email("Invalid email address")
        .required("Required"),
      currency: Yup.string().required("Required"),
      payerPhone: Yup.string()
        .min(8, "Invalid phone number")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      console.log("Form values:", values);
      const Name = values.payerName.split(" ");
      const firstName = Name[0];
      const lastName = Name[1] || "";

      // Find selected tax type
      const selectedTaxType = taxTypes.find(
        (tax) => tax.taxTypeId === values.taxType,
      );

      // console.log("Selected tax type:", selectedTaxType);
      const payload = {
        // key: "test_NzkyM2U5ZDE1MjBiOGZjNWY3NzZmNjczYTM3ODVhNWQ4MmU0YjYyNzYyMDFjM2I5MDA5MTMyYzliM2M1Y2NhNg",
        key: process.env.REACT_APP_IRS_KEY,
        email: values.payerEmail,
        amount: values.amount,
        currency: values.currency,
        first_name: firstName,
        last_name: lastName,
        phone_number: values.payerPhone,
        customerId: "",
        ref: `${Math.floor(Math.random() * 1000000000 + 1)}`,
        narration: selectedTaxType ? selectedTaxType.taxTypeId : values.taxType,
        meta: {
          MerchantType: "FIRS",
          tinNumber: values.tin,
          servicePurpose: selectedTaxType.taxTypeId,
        },
        callback: (response) => {
          console.log(response);
        },
        onSuccess: (response) => {
          window.scrollTo(0, 0);
          console.log(response);
          setModal(true);
          setModalMsg(response.message);
          setAmount(response.responseData.amount);
          setTransactionRefId(response.responseData.merchantTransactionRef);
        },
        onError: (response) => {
          console.log(response);
          alert("Error");
        },
        onClose: () => {
          console.log("window closed");
        },
      };
      // console.log("Payload:", payload);
      window.IcadPay.setup(payload);
    },
  });

  const handlemodal = () => {
    setModal(false);
  };

  // Effect to check form validity whenever values or TIN verification changes
  useEffect(() => {
    const checkFormValidity = () => {
      // Check if TIN is verified
      if (!tinVerified) {
        setIsFormValid(false);
        return;
      }

      // Check if all required fields are filled and valid
      const requiredFields = [
        "tin",
        "recipient",
        "taxType",
        "amount",
        "payerName",
        "payerEmail",
        "currency",
        "payerPhone",
      ];

      // Check if all required fields have values
      const allFieldsFilled = requiredFields.every(
        (field) =>
          formik.values[field] && formik.values[field].toString().trim() !== "",
      );

      // Check if amount is greater than 0
      const validAmount = parseFloat(formik.values.amount) > 0;

      // Check if there are no errors in any field
      const noErrors = Object.keys(formik.errors).length === 0;

      // Set form validity
      setIsFormValid(allFieldsFilled && validAmount && noErrors);
    };

    checkFormValidity();
  }, [formik.values, formik.errors, tinVerified]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const closeModal = () => {
    setModalOpen(false);
    setErrorModal(false);
  };

  const handleTaxTypeChange = (event) => {
    const selectedTaxTypeId = event.target.value;
    formik.setFieldValue("taxType", selectedTaxTypeId);

    // Reset amount to 0 when tax type changes, so the user can input their own amount
    formik.setFieldValue("amount", "");
  };

  const verifyTIN = async () => {
    if (!formik.values.tin || formik.errors.tin) {
      setVerificationMessage("Please enter a valid TIN");
      return;
    }

    setVerifyingTIN(true);
    try {
      // Call the FCT_IRS_VALIDATION endpoint with required headers
      const response = await axios.get(`${FCT_IRS_VALIDATION}/tinvalidation`, {
        params: {
          uid: formik.values.tin,
        },
        headers: {
          Authorization: `cad icad card`,
        },
      });

      // Check if the response is successful based on the actual response structure
      if (
        response.data &&
        response.data.requestSuccessful &&
        response.data.responseData
      ) {
        const taxpayerData = response.data.responseData;

        // Set the user data fields from the API response using the correct field names
        formik.setFieldValue("payerName", taxpayerData.name || "");
        formik.setFieldValue("payerEmail", taxpayerData.email || "");
        formik.setFieldValue("payerPhone", taxpayerData.phoneNumber || "");

        setVerificationMessage(
          response.data.message || "TIN verified successfully!",
        );
        setTinVerified(true);
      } else {
        // Handle case where TIN is not found or validation failed
        setVerificationMessage(
          response.data.message ||
            "TIN validation failed. Please check your TIN and try again.",
        );
      }
    } catch (error) {
      console.error("TIN verification error:", error);
      setVerificationMessage(
        error.response?.data?.message ||
          "Failed to verify TIN. Please check your connection and try again.",
      );
    } finally {
      setVerifyingTIN(false);
    }
  };

  return (
    <SupportFormContainter>
      <Paper>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} className="supportForm">
            {/* TIN Verification Section */}
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  p: 2,
                  borderRadius: "4px",
                  mb: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={8}>
                    <FormControl fullWidth>
                      <FormLabel htmlFor="tin">
                        Taxpayer Identification Number (TIN) *
                      </FormLabel>
                      <TextField
                        variant="outlined"
                        id="tin"
                        type="text"
                        placeholder="Enter your TIN"
                        {...formik.getFieldProps("tin")}
                        error={formik.touched.tin && Boolean(formik.errors.tin)}
                        disabled={tinVerified}
                      />
                      {formik.errors.tin && formik.touched.tin ? (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            paddingTop: "4px",
                          }}
                        >
                          {formik.errors.tin}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Button
                      variant="contained"
                      onClick={verifyTIN}
                      disabled={
                        verifyingTIN ||
                        tinVerified ||
                        !formik.values.tin ||
                        Boolean(formik.errors.tin)
                      }
                      sx={{ mt: { xs: 0, sm: 3 }, width: "100%", py: 1.5 }}
                    >
                      {verifyingTIN ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Verify TIN"
                      )}
                    </Button>
                  </Grid>
                </Grid>
                {verificationMessage && (
                  <Box sx={{ mt: 1, color: tinVerified ? "green" : "red" }}>
                    {verificationMessage}
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Personal Information Pre-Filled Section */}
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  p: 2,
                  borderRadius: "4px",
                  mb: 2,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormLabel
                      sx={{ fontWeight: "bold", display: "block", mb: 1 }}
                    >
                      Personal Information (Auto-filled from TIN)
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <FormLabel htmlFor="payerName">Name *</FormLabel>
                      <TextField
                        variant="outlined"
                        id="payerName"
                        type="text"
                        {...formik.getFieldProps("payerName")}
                        error={
                          formik.touched.payerName &&
                          Boolean(formik.errors.payerName)
                        }
                        disabled={!tinVerified}
                      />
                      {formik.errors.payerName && formik.touched.payerName ? (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            paddingTop: "4px",
                          }}
                        >
                          {formik.errors.payerName}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <FormLabel htmlFor="payerEmail">Email *</FormLabel>
                      <TextField
                        variant="outlined"
                        type="email"
                        id="payerEmail"
                        {...formik.getFieldProps("payerEmail")}
                        error={
                          formik.touched.payerEmail &&
                          Boolean(formik.errors.payerEmail)
                        }
                        disabled={!tinVerified}
                      />
                      {formik.errors.payerEmail && formik.touched.payerEmail ? (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            paddingTop: "4px",
                          }}
                        >
                          {formik.errors.payerEmail}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <FormLabel htmlFor="payerPhone">Phone Number *</FormLabel>
                      <TextField
                        variant="outlined"
                        type="tel"
                        id="payerPhone"
                        {...formik.getFieldProps("payerPhone")}
                        error={
                          formik.touched.payerPhone &&
                          Boolean(formik.errors.payerPhone)
                        }
                        disabled={!tinVerified}
                      />
                      {formik.errors.payerPhone && formik.touched.payerPhone ? (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            paddingTop: "4px",
                          }}
                        >
                          {formik.errors.payerPhone}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/* Payment Details Section - Only enabled after TIN verification */}
            {tinVerified && (
              <>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <FormLabel htmlFor="taxType">Select Tax Type *</FormLabel>
                    <Select
                      variant="outlined"
                      id="taxType"
                      displayEmpty
                      onChange={handleTaxTypeChange}
                      value={formik.values.taxType}
                      error={
                        formik.touched.taxType && Boolean(formik.errors.taxType)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select tax type
                      </MenuItem>
                      {taxTypes.map((tax) => (
                        <MenuItem key={tax.taxTypeId} value={tax.taxTypeId}>
                          {tax.taxTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.errors.taxType && formik.touched.taxType ? (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          paddingTop: "4px",
                        }}
                      >
                        {formik.errors.taxType}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel htmlFor="amount">Amount To Pay (★) *</FormLabel>
                    <TextField
                      variant="outlined"
                      id="amount"
                      type="text"
                      placeholder="0.00"
                      value={
                        formik.values.amount === "" ||
                        formik.values.amount === null
                          ? ""
                          : formatNumber(formik.values.amount)
                      }
                      onChange={(e) => {
                        const raw = parseNumber(e.target.value);
                        // Allow blank input
                        if (raw === "") {
                          formik.setFieldValue("amount", "");
                          return;
                        }

                        // Allow valid numbers
                        if (!isNaN(raw)) {
                          formik.setFieldValue("amount", raw);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.amount && Boolean(formik.errors.amount)
                      }
                      inputProps={{
                        inputMode: "decimal",
                      }}
                    />

                    {formik.errors.amount && formik.touched.amount ? (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          paddingTop: "4px",
                        }}
                      >
                        {formik.errors.amount}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <FormLabel htmlFor="currency">Select currency *</FormLabel>
                    <Select
                      variant="outlined"
                      id="currency"
                      {...formik.getFieldProps("currency")}
                      error={
                        formik.touched.currency &&
                        Boolean(formik.errors.currency)
                      }
                    >
                      {currencies.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.errors.currency && formik.touched.currency ? (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          paddingTop: "4px",
                        }}
                      >
                        {formik.errors.currency}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <ButtonDark
                    type="submit"
                    disabled={formik.isSubmitting || !isFormValid}
                    style={{
                      opacity: isFormValid ? 1 : 0.6,
                      cursor: isFormValid ? "pointer" : "not-allowed",
                    }}
                  >
                    {formik.isSubmitting && <Loader />} Submit Payment
                  </ButtonDark>
                  {!isFormValid && tinVerified && (
                    <div
                      style={{
                        color: "orange",
                        fontSize: "14px",
                        paddingTop: "8px",
                        textAlign: "center",
                      }}
                    >
                      Please fill in all required fields correctly to proceed
                      with payment
                    </div>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </form>

        <SweetAlert
          show={modalOpen}
          success
          title="Payment Submitted!"
          onConfirm={closeModal}
          confirmBtnText="Close"
          confirmBtnStyle={{
            padding: "8px 20px",
            backgroundColor: "green",
            borderRadius: "4px",
            color: "whitesmoke",
          }}
        >
          Your payment request has been submitted successfully
        </SweetAlert>
        <SweetAlert
          show={errorModal}
          error
          title="Oops!"
          onConfirm={closeModal}
          confirmBtnText="Close"
          confirmBtnStyle={{
            padding: "8px 20px",
            backgroundColor: "red",
            borderRadius: "4px",
            color: "whitesmoke",
          }}
          confirmBtnBsStyle="danger"
        >
          Something went wrong. Try again!
        </SweetAlert>
      </Paper>
      <Modal
        show={modal}
        close={handlemodal}
        amount={amount}
        TxnRef={transactionRefId}
        message={modalMsg}
      />
    </SupportFormContainter>
  );
};

export default MDAForm;
